import Component from 'vue-class-component'
import Vue from 'vue'
import authStore from '@/store/auth/auth-store';

@Component({
  name: 'endorseButtonNonauth',
  props: ['convo'],
})
export default class EndorseButtonNonauth extends Vue {

  protected login (): void {
    authStore.dispatchLogin()
  }

}
